import { api } from "../ApiState";
import { IApiResponse } from "../../Types/ApiResponse.model";

export const serviceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // list
    getServiceList: builder.query<any, { page?: number }>({
      query: ({ page }) => ({
        url: "event/service/list",
        method: "GET",
        params: { ...(page && { page }) },
      }),
      providesTags: ["Service"],
    }),

    // show
    showService: builder.query<any, number>({
      query: (id) => ({
        url: `event/service/show/${id}`,
        method: "GET",
      }),
      transformResponse(baseQueryReturnValue: IApiResponse) {
        return baseQueryReturnValue?.response?.data;
      },
      providesTags: ["Service"],
    }),

    // update
    updateService: builder.mutation<
      IApiResponse<any>,
      { id: number; value: object }
    >({
      query: ({ id, value }) => ({
        url: `event/service/update/${id}`,
        method: "POST",
        body: { ...value, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Service" }] : []),

    }),
  }),
});

export const {
  useGetServiceListQuery,
  useShowServiceQuery,
  useUpdateServiceMutation,
} = serviceApi;

export default serviceApi;
